import { Component, HostListener, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { AsyncPipe, NgIf } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { ImagePreviewService } from "./services/image-preview.service";
import { Observable } from "rxjs";
import { SafeUrl } from "@angular/platform-browser";

@Component({
    selector: "app-root",
    standalone: true,
    imports: [RouterOutlet, NgIf, AsyncPipe],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.css",
})
export class AppComponent implements OnInit {
    previewUrl$: Observable<SafeUrl | null>;

    constructor(
        private translate: TranslateService,
        private imagePreview: ImagePreviewService
    ) {
        this.previewUrl$ = this.imagePreview.url$;
    }

    ngOnInit() {
        this.translate.setDefaultLang("nl");
        this.translate.use("nl");
    }

    closePreview(): void {
        this.imagePreview.hide();
    }

    @HostListener("document:keydown.escape")
    onEscape(): void {
        this.imagePreview.hide();
    }
}
